var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg9 = function Svg9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4E5969",
    fillRule: "evenodd",
    d: "M21.75 19.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25v-15A2.25 2.25 0 0 1 4.5 2.25h15a2.25 2.25 0 0 1 2.25 2.25zm-18-15a.75.75 0 0 1 .75-.75h6.75v10.5h-7.5zm9 9.75h7.5v-4.5h-7.5zm7.5 1.5H3.75v3.75c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75zm-7.5-7.5h7.5V4.5a.75.75 0 0 0-.75-.75h-6.75z",
    clipRule: "evenodd"
  })));
};
export default Svg9;